import React from "react"
import autobind from "class-autobind"
import {Dialog, TextField, FlatButton, Chip, IconButton, FontIcon, Toggle} from "material-ui"
import strings from "../../localization/strings"
import { IGigPoolDocument } from "../../models/documents/GigPoolDocument"
import { IEmployeeStatus } from "../../models"
import * as api from "../../api"
import AccountStore from "../../stores/AccountStore"
import UserStatusDialog from "../../pages/jobs/job-details/job-detail-worker-pool/worker-pool-detail/UserStatusDialog"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"

interface IProps {
    handleClose(): void
    handleAdd(payload: IGigPoolDocument): void
    handleUpdate(payload: IGigPoolDocument): void
    gigPoolDoc: IGigPoolDocument
}

interface IState {
    name: string
    statusList: IEmployeeStatus[]
    employeeStatuses: IEmployeeStatus[]
    openStatusDialog: boolean
    coreStaff: boolean
    floatStaff: boolean
    perDiemStaff: boolean
    agencyStaff: boolean
}

export default class AddEditGigPoolItem extends React.Component<IProps, IState> {
        constructor(props: IProps) {
          super(props)
          this.state = {
            name: props.gigPoolDoc ? props.gigPoolDoc.Name : "",
            statusList: props.gigPoolDoc ? props.gigPoolDoc.EmployeeStatusList : [],
            coreStaff: props.gigPoolDoc ? props.gigPoolDoc.Core : false,
            floatStaff: props.gigPoolDoc ? props.gigPoolDoc.Float : false,
            perDiemStaff: props.gigPoolDoc ? props.gigPoolDoc.PerDiem : false,
            agencyStaff: props.gigPoolDoc ? props.gigPoolDoc.Agency : false,            
            employeeStatuses: [],
            openStatusDialog: false,
          }
          autobind(this)
        }

        save(){
            let payload = {
                Id: this.props.gigPoolDoc ? this.props.gigPoolDoc.Id : null,
                Name: this.state.name,
                EmployeeStatusList: this.state.statusList,
                Core: this.state.coreStaff,
                Float: this.state.floatStaff,
                PerDiem: this.state.perDiemStaff,
                Agency: this.state.agencyStaff,
            } as IGigPoolDocument

            if(this.props.gigPoolDoc){
                this.props.handleUpdate(payload)
            }else{
                this.props.handleAdd(payload)
            }
        }

        componentDidMount() {
            this.getEmployeeStatuses()
        }

        getEmployeeStatuses() {
            api.getEmployeeStatuses(AccountStore.getCurrentAccount().Id).then((response) => {
                this.setState({ employeeStatuses: response.data })
            })
        }
    
        handleRemoveEmployeeStatus = (Status) => {
            let changedStatusList = _.cloneDeep(this.state.statusList)
            changedStatusList = changedStatusList.filter(x => 
                !(x.Id === Status.Id && x.EmployeeSubStatus.Id === Status.EmployeeSubStatus.Id)
            )
            this.setState({statusList: changedStatusList})       
        }
    
        handleEmployeeStatusAdd = ({ Status, SubStatus }) => {
            let changedStatusList = _.cloneDeep(this.state.statusList)
            const isExist = this.state.statusList.find((x) => x.Id === Status.Id && x.EmployeeSubStatus.Id == SubStatus.Id)
            if (!isExist) {
                Status.EmployeeSubStatus = SubStatus
                Status.SubStatus = [SubStatus]
                changedStatusList.push(Status)      
                this.setState({statusList: changedStatusList})          
            } else {
                AppStateStore.setProgressSnackbarContent("Already Exists")
            }
    
            this.setState({ openStatusDialog: false })            
        }

        render() {
            return (
                <Dialog
                    open
                    title={strings.Gig_Pool}
                    style={{ minWidth: 900 }}
                    autoScrollBodyContent
                    actions={[
                        <span style={{ fontSize: 19, marginRight: 75, color: "#F57C00" }}>
                            {//this.state.noAccessErrorText
                            }
                        </span>,
                        <FlatButton
                            data-intercom-target={"Btn-Close-Hierarchy-Dialog"}
                            label={strings.CANCEL}
                            secondary
                            onTouchTap={() => {
                                //hierarchySettingsActions.receiveHierarchySelectedItem(HierarchySettingsStore.getGlobalLevelItemFilter())
                                this.props.handleClose()
                            }}
                        />,
                        <FlatButton
                            data-intercom-target={"Btn-Save-Selected-Hierarchy"}
                            label={strings.OK}
                            primary
                            onClick={() => {
                                this.save()
                            }}
                        />
                    ]}
                >
                    <div data-intercom-target={"gigpool-addedit-Dialog"}>
                        <div style={{ width: "100%" }}>
                            <TextField
                            data-intercom-target={"Break-Entry-Name"}
                            floatingLabelText={strings.Name}
                            value={this.state.name}
                            onChange={(e, value) => { this.setState({ name: value })}}
                            //errorText={this.state.errorName}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                            fullWidth
                            //disabled={this.props.editBreak && this.props.editBreak.Used}
                            />

                            <div>
                                <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                    User Status List
                                </div>
                                <div style={{ gridColumn: "span 2", gridRow: "auto", paddingBottom: 10 }}>
                                    {this.state.statusList &&
                                        this.state.statusList.map((employeeStatus, index) =>
                                            <Chip
                                                style={{ marginTop: 10, marginRight: 5, display: "inline-flex" }}
                                                onRequestDelete={() => { this.handleRemoveEmployeeStatus(employeeStatus as any) }}
                                                key={index}
                                            >
                                                {employeeStatus.EmployeeSubStatus && <span>{employeeStatus.Name}: {employeeStatus.EmployeeSubStatus.Name}</span>}
                                                {!employeeStatus.EmployeeSubStatus && <span>{employeeStatus.Name}</span>}
                                            </Chip>
                                        )}

                                    <IconButton
                                        style={{ height: 33, display: "inline-flex" }}
                                        onTouchTap={() => {
                                            this.setState({ openStatusDialog: true })
                                        }}
                                    >
                                        <div style={{ paddingTop: 10 }}>
                                            <FontIcon className="fa fa-plus-circle" />
                                        </div>
                                    </IconButton>

                                </div>      
                                <div style={{display: "grid"}}>
                                    <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                        <Toggle
                                            toggled={this.state.coreStaff}
                                            onToggle={(event, value) => {
                                                this.setState({ coreStaff: value })
                                            }}
                                            labelPosition="left"
                                            label={"Core Staff"}
                                        />
                                    </div>     
                                    
                                    <div style={{ gridColumn: 2, gridRow: "auto", marginLeft: 10 }}>
                                        <Toggle
                                            toggled={this.state.floatStaff}
                                            onToggle={(event, value) => {
                                                this.setState({ floatStaff: value })
                                            }}
                                            labelPosition="left"
                                            label={"Float Staff"}
                                        />
                                    </div> 

                                    <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                        <Toggle
                                            toggled={this.state.perDiemStaff}
                                            onToggle={(event, value) => {
                                                this.setState({ perDiemStaff: value })
                                            }}
                                            labelPosition="left"
                                            label={"Per Diem Staff"}
                                        />
                                    </div>     

                                    <div style={{ gridColumn: 2, gridRow: "auto", marginLeft: 10 }}>
                                        <Toggle
                                            toggled={this.state.agencyStaff}
                                            onToggle={(event, value) => {
                                                this.setState({ agencyStaff: value })
                                            }}
                                            labelPosition="left"
                                            label={"Agency Staff"}
                                        />
                                    </div> 
                                </div>                                                          
                            </div>
                        </div>                
                    </div>
                    {this.state.openStatusDialog &&
                        <UserStatusDialog
                            open={this.state.openStatusDialog}
                            onClose={() => this.setState({ openStatusDialog: false })}
                            onStatusSelection={this.handleEmployeeStatusAdd}
                            statuses={this.state.employeeStatuses}
                        />
                    }                       
                </Dialog>
           )
        }
}